<rask-button
    class="col-3 text-center"
    color="secondary"
    (click)="avsluta()"
    [disabled]="!canAvsluta"
    >
    Avsluta avtalsobjekt
</rask-button>
